import React, { useEffect, useState } from 'react';
import API from '../../API/API';
import { useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Form } from 'antd';
const CardComponent = ({ title, children, extra, style }) => {
    return (
        <div style={{
            border: '1px solid #eee',
            borderRadius: '8px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            ...style
        }}>
            {title && (
                <div style={{
                    padding: '16px 20px',
                    borderBottom: '1px solid #eee',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div style={{ fontWeight: 'bold', fontSize: '18px' }}>{title}</div>
                    {extra && <div>{extra}</div>}
                </div>
            )}
            <div style={{ padding: '20px' }}>
                {children}
            </div>
        </div>
    );
};

const Badge = ({ children, color }) => {
    const colorMap = {
        blue: { background: '#e6f7ff', color: '#1890ff', border: '#91d5ff' },
        green: { background: '#f6ffed', color: '#52c41a', border: '#b7eb8f' },
        red: { background: '#fff1f0', color: '#f5222d', border: '#ffa39e' },
        orange: { background: '#fff7e6', color: '#fa8c16', border: '#ffd591' },
        purple: { background: '#f9f0ff', color: '#722ed1', border: '#d3adf7' },
        cyan: { background: '#e6fffb', color: '#13c2c2', border: '#87e8de' },
        gray: { background: '#fafafa', color: '#8c8c8c', border: '#d9d9d9' }
    };

    const colorStyle = colorMap[color] || colorMap.blue;

    return (
        <span style={{
            padding: '2px 8px',
            fontSize: '12px',
            borderRadius: '4px',
            backgroundColor: colorStyle.background,
            color: colorStyle.color,
            border: `1px solid ${colorStyle.border}`,
            marginRight: '8px'
        }}>
            {children}
        </span>
    );
};

const Button = ({ type, children, onClick, icon, style, disabled ,href }) => {
    const baseStyle = {
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        transition: 'all 0.3s',
        border: 'none',
        boxShadow: '0 2px 0 rgba(0,0,0,0.015)',
        outline: 'none',
        margin: '4px 0',
        width: '100%',
        opacity: disabled ? 0.5 : 1,
        textDecoration: "none",
    };

    let typeStyle = {};

    switch (type) {
        case 'primary':
            typeStyle = {
                backgroundColor: '#1890ff',
                color: 'white',
                border: '1px solid #1890ff'
            };
            break;
        case 'danger':
            typeStyle = {
                backgroundColor: '#f5222d',
                color: 'white',
                border: '1px solid #f5222d'
            };
            break;
        default:
            typeStyle = {
                backgroundColor: 'white',
                color: 'rgba(0, 0, 0, 0.85)',
                border: '1px solid #d9d9d9'
            };
    }
    const Component = href ? 'a' : 'button';

    return (
        <Component
        onClick={href ? null : disabled ? null : onClick} // Prevent onClick if href is used
        style={{
            ...baseStyle,
            ...typeStyle,
            ...style,
        }}
        disabled={!href && disabled}
        href={href} // Only apply href if it's a link
    >
        {icon && <span style={{ marginRight: '8px' }}>{icon}</span>}
        {children}
    </Component>
    );
};

const Avatar = ({ children, style, backgroundColor }) => {
    return (
        <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: backgroundColor || '#1890ff',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            ...style
        }}>
            {children}
        </div>
    );
};

const Divider = () => {
    return <div style={{ height: '1px', backgroundColor: '#f0f0f0', margin: '16px 0' }} />;
};

const Timeline = ({ children }) => {
    return (
        <div style={{ marginLeft: '20px' }}>
            {children}
        </div>
    );
};

const TimelineItem = ({ color, label, children }) => {
    const colorMap = {
        green: '#52c41a',
        blue: '#1890ff',
        red: '#f5222d',
        gray: '#8c8c8c'
    };

    const dotColor = colorMap[color] || colorMap.blue;

    return (
        <div style={{ position: 'relative', paddingBottom: '20px' }}>
            <div style={{
                position: 'absolute',
                left: '-20px',
                top: '8px',
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: dotColor,
                border: '2px solid white',
                boxShadow: `0 0 0 1px ${dotColor}`
            }} />

            <div style={{
                position: 'absolute',
                left: '-15.5px',
                top: '18px',
                width: '1px',
                height: 'calc(100% - 8px)',
                backgroundColor: '#f0f0f0'
            }} />

            <div style={{ marginBottom: '8px', color: '#8c8c8c', fontSize: '13px' }}>
                {label}
            </div>

            <div>
                {children}
            </div>
        </div>
    );
};

const Statistic = ({ title, value, prefix, suffix, precision }) => {
    const formattedValue = typeof value === 'number'
        ? value.toFixed(precision || 0)
        : value;

    return (
        <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '14px', color: '#8c8c8c', marginBottom: '4px' }}>
                {title}
            </div>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
                {prefix}{formattedValue}{suffix}
            </div>
        </div>
    );
};

const Step = ({ current, steps }) => {
    console.log(current)
    return (
        <div style={{ margin: '20px 0' }}>
            {steps.map((step, index) => (
                <div key={index} style={{
                    display: 'flex',
                    marginBottom: '16px',
                    alignItems: 'flex-start'
                }}>
                    <div style={{
                        backgroundColor: index <= current ? '#1890ff' : '#f0f0f0',
                        color: index <= current ? 'white' : '#8c8c8c',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        marginRight: '12px',
                        fontSize: '14px',
                        fontWeight: 'bold'
                    }}>
                        {index + 1}
                    </div>
                    <div>
                        <div style={{
                            fontWeight: 'bold',
                            color: index === current ? '#1890ff' : 'rgba(0, 0, 0, 0.85)'
                        }}>
                            {step.title}
                        </div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                            {step.description}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

const DescriptionList = ({ items }) => {
    return (
        <div style={{ marginBottom: '16px' }}>
            {items.map((item, index) => (
                <div key={index} style={{ marginBottom: '8px' }}>
                    <div style={{ fontSize: '14px', color: '#8c8c8c', marginBottom: '4px' }}>
                        {item.label}
                    </div>
                    <div>{item.value}</div>
                </div>
            ))}
        </div>
    );
};

// Form components
const FormItem = ({ label, children, error }) => {
    return (
        <div style={{ marginBottom: '16px' }}>
            <div style={{ marginBottom: '8px', fontSize: '14px' }}>{label}</div>
            {children}
            {error && <div style={{ color: '#f5222d', fontSize: '12px', marginTop: '4px' }}>{error}</div>}
        </div>
    );
};

const Input = ({ value, onChange, placeholder, type = "text", style }) => {
    return (
        <input
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                fontSize: '14px',
                ...style
            }}
        />
    );
};

const TextArea = ({ value, onChange, placeholder, rows = 3, style }) => {
    return (
        <textarea
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={rows}
            style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                fontSize: '14px',
                resize: 'vertical',
                ...style
            }}
        />
    );
};

const Select = ({ value, onChange, options, style }) => {
    return (
        <select
            value={value}
            onChange={onChange}
            style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                fontSize: '14px',
                ...style
            }}
        >
            {options.map((option, index) => (
                <option key={index} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

// Modal component
const Modal = ({ visible, title, onClose, children, footer }) => {
    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                width: '480px',
                maxWidth: '90%',
                maxHeight: '80vh',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    padding: '16px 24px',
                    borderBottom: '1px solid #f0f0f0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{title}</div>
                    <div
                        onClick={onClose}
                        style={{ cursor: 'pointer', fontSize: '18px' }}
                    >
                        ×
                    </div>
                </div>
                <div style={{
                    padding: '24px',
                    overflowY: 'auto'
                }}>
                    {children}
                </div>
                {footer && (
                    <div style={{
                        padding: '12px 24px',
                        borderTop: '1px solid #f0f0f0',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '8px'
                    }}>
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

// Icons
const UserIcon = () => <span>👤</span>;
const CarIcon = () => <span>🚗</span>;
const PhoneIcon = () => <span>📱</span>;
const MailIcon = () => <span>✉️</span>;
const DollarIcon = () => <span>💰</span>;
const InfoIcon = () => <span>ℹ️</span>;
const RefundIcon = () => <span>↩️</span>;

// Enhanced API functionality
const EnhancedAPI = {
    ...API,
    GetPaymentSummary: async (id) => {
        try {
            const response = await fetch(`${Config.baseURL}/api/payments/${id}/summary`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return await response.json();
        } catch (error) {
            throw new Error('Failed to fetch payment summary');
        }
    },

    CreateQuote: async (id, quoteData) => {
        try {
            const response = await fetch(`${Config.baseURL}/api/payments/${id}/quotes`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(quoteData),
            });
            return await response.json();
        } catch (error) {
            throw new Error('Failed to create quote');
        }
    },

    UpdatePaymentStatus: async (id, status, data) => {
        try {
            const response = await fetch(`${Config.baseURL}/api/payments/${id}/${status}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            return await response.json();
        } catch (error) {
            throw new Error(`Failed to update payment status to ${status}`);
        }
    },

    RefundPayment: async (id, paymentId, data) => {
        try {
            const response = await fetch(`${Config.baseURL}/api/payments/${id}/refund/${paymentId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            return await response.json();
        } catch (error) {
            throw new Error('Failed to refund payment');
        }
    },

    RecordNewPayment: async (id, paymentData) => {
        try {
            const response = await fetch(`${Config.baseURL}/api/payments/${id}/payments`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(paymentData),
            });
            return await response.json();
        } catch (error) {
            throw new Error('Failed to record payment');
        }
    }
};

const EmailTemplateModal = ({ visible, onCancel, onSend, customer, userData }) => {
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSendEmail = async () => {
        setIsLoading(true);
        try {
            const textContent = body
                .replace(/<p>/g, '\n')
                .replace(/<br\s*\/?>/g, '\n')
                .replace(/&nbsp;/g, ' ')
                .replace(/<\/?[^>]+(>|$)/g, '');

            const emailData = {
                to: customer.personalInfo.email,
                subject: subject,
                text: textContent.trim(),
                html: `<html><body style="font-family: Arial, sans-serif; line-height: 1.6; padding: 10px;">${body}</body></html>`,
                agentId: userData?.id,
            };

            const response = await axios.post(`${Config.baseURL}/api/send-email`, emailData);
            if (response.status) {
                message.success('Email sent successfully!');
                onCancel();
            }
        } catch (error) {
            console.error('Failed to send email:', error);
            message.error('Failed to send email. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link'
    ];

    useEffect(() => {
        if (visible && customer) {
            const defaultBody = `
                <p>Dear ${customer.personalInfo.fullName},</p>
                <p>I hope this message finds you well. I wanted to follow up on your recent inquiry about the <strong>${customer.vehicleInfo.part}</strong> for your <strong>${customer.vehicleInfo.year} ${customer.vehicleInfo.make} ${customer.vehicleInfo.model}</strong>.</p>
                <p>Here's a quick recap of the details we discussed:</p>
                <ul>
                    <li><strong>Part:</strong> ${customer.vehicleInfo.part}</li>
                    <li><strong>Vehicle:</strong> ${customer.vehicleInfo.year} ${customer.vehicleInfo.make} ${customer.vehicleInfo.model}</li>
                    <li><strong>Total price:</strong> $${customer.amount?.[customer.quotes.length - 1]?.amount || 'N/A'}</li>
                                        <li><strong>Advance price:</strong> $${customer.advancePayment?.[customer.quotes.length - 1]?.advancePayment || 'N/A'}</li>

                </ul>
                <p>Best regards,</p>
                <p><strong>${userData?.firstName} ${userData?.lastName}</strong></p>
            `;
            setBody(defaultBody);
            setSubject(`Payment pending${customer.vehicleInfo.part}`);
        }
    }, [visible, customer, userData]);

    return (
        <Modal
            title="Send Follow-Up Email"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>Cancel</Button>,
                <Button key="send" type="primary" onClick={handleSendEmail} loading={isLoading}>
                    Send Email
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <Form.Item label="To">
                    <Input value={customer?.personalInfo?.email || ''} disabled />
                </Form.Item>
                <Form.Item label="Subject" rules={[{ required: true, message: 'Please enter a subject' }]}>
                    <Input placeholder="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
                </Form.Item>
                <Form.Item label="Body" rules={[{ required: true, message: 'Please enter the email body' }]}>
                    <ReactQuill
                        value={body}
                        onChange={setBody}
                        modules={modules}
                        formats={formats}
                        placeholder="Compose your email..."
                        style={{ height: '200px', marginBottom: '40px', borderRadius: '8px' }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

const PaymentPending = () => {
    const { id } = useParams();
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);


    // Modal states
    // const [quoteModalVisible, setQuoteModalVisible] = useState(false);
    const [paymentModalVisible, setPaymentModalVisible] = useState(false);
    const [pendingModalVisible, setPendingModalVisible] = useState(false);
    const [completeModalVisible, setCompleteModalVisible] = useState(false);
    const [refundModalVisible, setRefundModalVisible] = useState(false);
    const [selectedPaymentId, setSelectedPaymentId] = useState(null);
    const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);

    const [userData, setUserData] = useState(null);

    // Email state
    const [emailModalVisible, setEmailModalVisible] = useState(false);
    const [emailData, setEmailData] = useState({
        to: '',
        subject: '',
        html: '',
        agentId: ''
    });
    const [sendingEmail, setSendingEmail] = useState(false);

    // Form states
    const [quoteForm, setQuoteForm] = useState({
        amount: '',
        advancePayment: '',
        description: ''
    });

    const [paymentForm, setPaymentForm] = useState({
        amount: '',
        paymentMethod: 'Credit Card',
        description: ''
    });

    const [commentForm, setCommentForm] = useState({
        comment: ''
    });

    const [refundForm, setRefundForm] = useState({
        reason: ''
    });


    const getEmailTemplate = (customerData) => {
        return `
            <p>Dear ${customerData.personalInfo?.fullName || 'Customer'},</p>
            <p>Thank you for your interest in our ${customerData.serviceType} services.</p>
            ${customerData.paymentStatus === 'pending' ?
                '<p>We noticed your payment is currently pending. Please complete the payment to proceed.</p>' :
                ''}
            <p>Please don't hesitate to contact us if you have any questions.</p>
            <p>Best regards,<br/>Your Agent</p>
        `;
    };


    useEffect(() => {
        const fetchCustomerData = async () => {
            try {
                setLoading(true);
                // First try to get the payment summary
                try {
                    const summaryResponse = await EnhancedAPI.GetPaymentSummary(id);
                    console.log("Payment summary response:", summaryResponse);

                    if (summaryResponse?.status) {
                        setCustomer(summaryResponse.data);
                        setEmailData({
                            to: response.data.personalInfo?.email || '',
                            subject: `Regarding your ${response.data.serviceType} inquiry`,
                            html: getEmailTemplate(response.data),
                            agentId: JSON.parse(localStorage.getItem('userData')?.id) // Replace with actual agent ID
                        });
                        setLoading(false);
                        return;
                    }
                } catch (err) {
                    console.log("Payment summary not available, falling back to lead data");
                }

                // Fallback to the original API call
                const response = await API.GetLeadById(id);
                if (response?.status) {
                    setCustomer(response.data);
                }
                setLoading(false);
            } catch (err) {
                setError(err.message || 'Failed to fetch customer data');
                setLoading(false);
            }
        };
        const storedUserData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData'))
        : null;
    setUserData(storedUserData);
        fetchCustomerData();
    }, [id, refreshTrigger]);

    const handleSendEmail = async () => {
        try {
            setSendingEmail(true);
            const response = await fetch(`${Config.baseURL}/api/send-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(emailData),
            });

            const result = await response.json();
            if (result.success) {
                alert('Email sent successfully!');
                setEmailModalVisible(false);
            } else {
                alert('Failed to send email: ' + (result.message || 'Unknown error'));
            }
        } catch (error) {
            alert('Error sending email: ' + error.message);
        } finally {
            setSendingEmail(false);
        }
    };

    const handleEmailChange = (value) => {
        setEmailData(prev => ({
            ...prev,
            html: value
        }));
    };

    const handleEmailSubjectChange = (e) => {
        setEmailData(prev => ({
            ...prev,
            subject: e.target.value
        }));
    };



    const getLeadStageNumber = (stage) => {
        const stages = ["Lead Created", "Contacted", "Quote Sent", "Pending Payment", "Payment Completed",
            //  "Order Fulfilled"
        ];
        return stages.indexOf(stage) !== -1 ? stages.indexOf(stage) : 0;
    };

    const getAdvancePaymentTotal = () => {
        const paymentsFromAdvancePayments = customer?.advancePayments?.reduce((total, payment) => total + payment.amount, 0) || 0;
        const paymentsFromQuotes = customer?.quotes?.reduce((total, quote) => total + (quote.advancePayment || 0), 0) || 0;
        return paymentsFromAdvancePayments + paymentsFromQuotes;
    };

    // getQuoteTotal remains the same
    const getQuoteTotal = () => {
        return customer?.quotes?.reduce((total, quote) => total + quote.amount, 0) || 0;
    };

    // getRemainingBalance would then correctly account for all advance payments
    const getRemainingBalance = () => {
        return getQuoteTotal() - getAdvancePaymentTotal();
    };
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const refreshData = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    // Form handlers
    

    const handlePaymentFormChange = (field) => (e) => {
        setPaymentForm({
            ...paymentForm,
            [field]: field === 'amount'
                ? (e.target.value === '' ? '' : parseFloat(e.target.value))
                : e.target.value
        });
    };

    const handleCommentFormChange = (e) => {
        setCommentForm({
            comment: e.target.value
        });
    };

    const handleRefundFormChange = (e) => {
        setRefundForm({
            reason: e.target.value
        });
    };

    // API action handlers
    // const handleCreateQuote = async () => {
    //     try {
    //         const response = await EnhancedAPI.CreateQuote(id, quoteForm);
    //         if (response.status) {
    //             setQuoteModalVisible(false);
    //             setQuoteForm({
    //                 amount: '',
    //                 advancePayment: '',
    //                 description: ''
    //             });
    //             refreshData();
    //         } else {
    //             alert(response.message || "Failed to create quote");
    //         }
    //     } catch (error) {
    //         alert(error.message);
    //     }
    // };

    const handleRecordPayment = async () => {
        try {
            const response = await EnhancedAPI.RecordNewPayment(id, paymentForm);
            if (response.status) {
                setPaymentModalVisible(false);
                setPaymentForm({
                    amount: '',
                    paymentMethod: 'Credit Card',
                    description: ''
                });
                
                refreshData();
            } else {
                alert(response.message || "Failed to record payment");
            }
        } catch (error) {
            alert(error.message);
        }
    };

    const handleUpdateToPending = async () => {
        try {
            const response = await EnhancedAPI.UpdatePaymentStatus(id, 'pending', commentForm);
            if (response.status) {
                setPendingModalVisible(false);
                setCommentForm({ comment: '' });
                refreshData();
            } else {
                alert(response.message || "Failed to update to pending");
            }
        } catch (error) {
            alert(error.message);
        }
    };

    const handleUpdateToCompleted = async () => {
        try {
            const response = await EnhancedAPI.UpdatePaymentStatus(id, 'completed', commentForm);
            if (response.status) {
                setCompleteModalVisible(false);
                setCommentForm({ comment: '' });
                refreshData();
            } else {
                alert(response.message || "Failed to mark as completed");
            }
        } catch (error) {
            alert(error.message);
        }
    };

    const handleRefundPayment = async () => {
        try {
            const response = await EnhancedAPI.RefundPayment(id, selectedPaymentId, refundForm);
            if (response.status) {
                setRefundModalVisible(false);
                setRefundForm({ reason: '' });
                setSelectedPaymentId(null);
                refreshData();
            } else {
                alert(response.message || "Failed to refund payment");
            }
        } catch (error) {
            alert(error.message);
        }
    };

    const showRefundModal = (paymentId) => {
        setSelectedPaymentId(paymentId);
        setRefundModalVisible(true);
    };

    const leadStageSteps = [
        { title: "Lead Created", description: "Initial inquiry" },
        { title: "Contacted", description: "Customer contacted" },
        { title: "Quote Sent", description: "Pending approval" },
        { title: "Pending Payment", description: "Waiting for full payment" },
        { title: "Payment Completed", description: "Ready for fulfillment" },
        // { title: "Order Fulfilled", description: "Service completed" }
    ];

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <div>Loading customer data...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <div style={{ color: '#f5222d' }}>Error: {error}</div>
            </div>
        );
    }

    if (!customer) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <div>No customer data found</div>
            </div>
        );
    }

    const currentLeadStage = getLeadStageNumber(customer.leadStage);
    const isPendingOrAfter = currentLeadStage >= 3;
    const isCompleted = currentLeadStage >= 4;


    return (
        <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', margin: '0 -12px' }}>
                {/* Customer Overview Card */}
                <div style={{ width: '100%', padding: '0 12px', marginBottom: '24px', boxSizing: 'border-box', flex: '1 1 33.33%', minWidth: '300px' }}>
                    <CardComponent
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar backgroundColor="#1890ff"><UserIcon /></Avatar>
                                <div style={{ marginLeft: '16px' }}>
                                    <div style={{ fontWeight: 'bold', fontSize: '18px' }}>Customer Details</div>
                                    <Badge color={customer.isExistingCustomer ? "green" : "blue"}>
                                        {customer.isExistingCustomer ? "Existing Customer" : "New Customer"}
                                    </Badge>
                                </div>
                            </div>
                        }
                    >
                        <DescriptionList
                            items={[
                                { label: "Name", value: customer?.personalInfo?.fullName },
                                { label: "Email", value: <a href={`mailto:${customer?.personalInfo?.email}`} style={{ color: '#1890ff', textDecoration: 'none' }}>{customer?.personalInfo?.email}</a> },
                                { label: "Phone", value: <a href={`tel:${customer?.personalInfo?.phoneNumber}`} style={{ color: '#1890ff', textDecoration: 'none' }}>{customer?.personalInfo?.phoneNumber}</a> },
                                { label: "ZIP Code", value: customer?.personalInfo?.zipCode },
                                { label: "Lead Type", value: <Badge color={customer.leadType === "outbound" ? "purple" : "cyan"}>{customer?.leadType?.charAt(0)?.toUpperCase() + customer?.leadType?.slice(1)}</Badge> },
                                { label: "Created On", value: formatDate(customer?.createdAt) }
                            ]}
                        />

                        <Divider />

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <Button type="primary" icon={<PhoneIcon />}
                                href={`tel:${customer.personalInfo?.phoneNumber}`}

                            >Contact Customer</Button>

                            <Button icon={<MailIcon />}
                               block
                               size="large"
                               onClick={() => setIsEmailModalVisible(true)}
                               disabled={!customer.personalInfo?.email}
                               >Send Email</Button>
                        </div>
                    </CardComponent>
                </div>

                {/* Vehicle Information Card */}
                <div style={{ width: '100%', padding: '0 12px', marginBottom: '24px', boxSizing: 'border-box', flex: '1 1 33.33%', minWidth: '300px' }}>
                    <CardComponent
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar backgroundColor="#52c41a"><CarIcon /></Avatar>
                                <div style={{ marginLeft: '16px' }}>
                                    <div style={{ fontWeight: 'bold', fontSize: '18px' }}>Vehicle Details</div>
                                </div>
                            </div>
                        }
                    >
                        <DescriptionList
                            items={[
                                { label: "Make", value: customer?.vehicleInfo?.make },
                                { label: "Model", value: customer?.vehicleInfo?.model },
                                { label: "Year", value: customer?.vehicleInfo?.year },
                                { label: "Part Needed", value: customer?.vehicleInfo?.part },
                                { label: "VIN Number", value: customer?.vehicleInfo?.vin }

                            ]}
                        />

                        <Divider />

                        <div style={{
                            padding: '12px',
                            backgroundColor: '#f6ffed',
                            borderRadius: '8px',
                            border: '1px solid #b7eb8f',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <InfoIcon />
                            <span style={{ color: '#52c41a' }}>This part is compatible with the vehicle</span>
                        </div>
                    </CardComponent>
                </div>

                {/* Financial Summary Card */}
                <div style={{ width: '100%', padding: '0 12px', marginBottom: '24px', boxSizing: 'border-box', flex: '1 1 33.33%', minWidth: '300px' }}>
                    <CardComponent
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar backgroundColor="#faad14"><DollarIcon /></Avatar>
                                <div style={{ marginLeft: '16px' }}>
                                    <div style={{ fontWeight: 'bold', fontSize: '18px' }}>Financial Summary</div>
                                </div>
                            </div>
                        }
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <Statistic
                                title="Quote Total"
                                value={getQuoteTotal()}
                                precision={2}
                                prefix="$"
                            />
                            <Statistic
                                title="Advance Paid"
                                value={getAdvancePaymentTotal()}
                                precision={2}
                                prefix="$"
                            />
                            <Statistic
                                title="Remaining"
                                value={getRemainingBalance()}
                                precision={2}
                                prefix="$"
                            />
                        </div>

                        <Divider />

                        {/* <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Lead Status</div>
                        <Step
                            current={currentLeadStage}
                            steps={leadStageSteps}
                        />

                        <Divider /> */}

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {/* <Button
                                type="primary"
                                icon={<DollarIcon />}
                                onClick={() => setQuoteModalVisible(true)}
                                disabled={quoteForm.amount === quoteForm.advancePayment }
                            >
                                Create New Quote
                            </Button> */}

                            <Button
                                type={isPendingOrAfter ? "default" : "primary"}
                                icon={<DollarIcon />}
                                onClick={() => setPaymentModalVisible(true)}
                                disabled={getRemainingBalance() === 0} // Disable when total is 0
                            
                                >
                                Record Payment
                            </Button>

                            {!isPendingOrAfter && (
                                <Button
                                    type="primary"
                                    icon={<DollarIcon />}
                                    onClick={() => setPendingModalVisible(true)}
                                    disabled={getRemainingBalance() === 0} // Disable when total is 0
                                >
                                    Mark as Pending Payment
                                </Button>
                            )}

                            {isPendingOrAfter && !isCompleted && (
                                <Button
                                    type="primary"
                                    icon={<DollarIcon />}
                                    onClick={() => setCompleteModalVisible(true)}
                                    disabled={quoteForm.amount === quoteForm.advancePayment}
                                >
                                    Mark as Completed
                                </Button>
                            )}
                        </div>
                    </CardComponent>
                </div>
            </div>

            {/* Quotes and Payments Section */}
            <div style={{ display: 'flex', flexWrap: 'wrap', margin: '0 -12px' }}>
                {/* Quotes Card */}
                <div style={{ width: '100%', padding: '0 12px', marginBottom: '24px', boxSizing: 'border-box', flex: '1 1 50%', minWidth: '300px' }}>
                    <CardComponent title="Quotes">
                        {customer?.quotes?.length > 0 ? (
                            <Timeline>
                                {customer.quotes.map((quote, index) => (
                                    <TimelineItem
                                        key={index}
                                        label={`${formatDate(quote.date)} - $${quote.amount.toFixed(2)}`}
                                        color="blue"
                                    >
                                        <div style={{ marginBottom: '8px' }}>
                                            <strong>Description:</strong> {quote.description || 'No description provided'}
                                        </div>
                                        <div>
                                            <strong>Advance Payment:</strong> ${quote.advancePayment?.toFixed(2) || '0.00'}
                                        </div>
                                    </TimelineItem>
                                ))}
                            </Timeline>
                        ) : (
                            <div style={{ textAlign: 'center', color: '#8c8c8c' }}>
                                No quotes have been created for this customer
                            </div>
                        )}
                    </CardComponent>
                </div>

                {/* Payments Card */}
                <div style={{ width: '100%', padding: '0 12px', marginBottom: '24px', boxSizing: 'border-box', flex: '1 1 50%', minWidth: '300px' }}>
                    <CardComponent title="Payments">
                        {customer?.advancePayments?.length > 0 ? (
                            <Timeline>
                                {customer.advancePayments.map((payment, index) => (
                                    <TimelineItem
                                        key={index}
                                        label={`${formatDate(payment.date)} - $${payment.amount.toFixed(2)}`}
                                        color={payment.status === 'refunded' ? 'red' : 'green'}
                                    >
                                        <div style={{ marginBottom: '8px' }}>
                                            <strong>Method:</strong> {payment.paymentMethod}
                                        </div>
                                        <div style={{ marginBottom: '8px' }}>
                                            <strong>Status:</strong>
                                            <Badge
                                                color={
                                                    payment.status === 'completed' ? 'green' :
                                                        payment.status === 'pending' ? 'orange' :
                                                            payment.status === 'refunded' ? 'red' : 'gray'
                                                }
                                            >
                                                {payment.status.charAt(0).toUpperCase() + payment.status.slice(1)}
                                            </Badge>
                                        </div>
                                        {payment.status === 'completed' && (
                                            <Button
                                                type="danger"
                                                size="small"
                                                icon={<RefundIcon />}
                                                onClick={() => showRefundModal(payment._id)}
                                            >
                                                Refund Payment
                                            </Button>
                                        )}
                                    </TimelineItem>
                                ))}
                            </Timeline>
                        ) : (
                            <div style={{ textAlign: 'center', color: '#8c8c8c' }}>
                                No payments have been recorded for this customer
                            </div>
                        )}
                    </CardComponent>
                </div>
            </div>

            {/* Create Quote Modal */}
            {/* <Modal
                visible={quoteModalVisible}
                title="Create New Quote"
                onClose={() => setQuoteModalVisible(false)}
                footer={
                    <>
                        <Button onClick={() => setQuoteModalVisible(false)}>Cancel</Button>
                        <Button type="primary" onClick={handleCreateQuote}>Create Quote</Button>
                    </>
                }
            >
                <FormItem label="Quote Amount">
                    <Input
                        type="number"
                        value={quoteForm.amount}
                        onChange={handleQuoteFormChange('amount')}
                        placeholder="Enter quote amount"
                    />
                </FormItem>
                <FormItem label="Advance Payment">
                    <Input
                        type="number"
                        value={quoteForm.advancePayment}
                        onChange={handleQuoteFormChange('advancePayment')}
                        placeholder="Enter advance payment amount"
                    />
                </FormItem>
                <FormItem label="Description">
                    <TextArea
                        value={quoteForm.description}
                        onChange={handleQuoteFormChange('description')}
                        placeholder="Enter quote description"
                    />
                </FormItem>
            </Modal> */}

            {/* Record Payment Modal */}
            <Modal
                visible={paymentModalVisible}
                title="Record New Payment"
                onClose={() => setPaymentModalVisible(false)}
                footer={
                    <>
                        <Button onClick={() => setPaymentModalVisible(false)}>Cancel</Button>
                        <Button type="primary" onClick={handleRecordPayment}>Record Payment</Button>
                    </>
                }
            >
                <FormItem label="Amount">
                    <Input
                        type="number"
                        value={paymentForm.amount}
                        onChange={handlePaymentFormChange('amount')}
                        placeholder="Enter payment amount"
                    />
                </FormItem>
                <FormItem label="Payment Method">
                    <Select
                        value={paymentForm.paymentMethod}
                        onChange={handlePaymentFormChange('paymentMethod')}
                        options={[
                            { value: 'Credit Card', label: 'Credit Card' },
                            { value: 'Bank Transfer', label: 'Bank Transfer' },
                            { value: 'Cash', label: 'Cash' },
                            { value: 'Check', label: 'Check' },
                            { value: 'Other', label: 'Other' }
                        ]}
                    />
                </FormItem>
                <FormItem label="Description">
                    <TextArea
                        value={paymentForm.description}
                        onChange={handlePaymentFormChange('description')}
                        placeholder="Enter payment description"
                    />
                </FormItem>
            </Modal>

            {/* Mark as Pending Modal */}
            <Modal
                visible={pendingModalVisible}
                title="Mark as Pending Payment"
                onClose={() => setPendingModalVisible(false)}
                footer={
                    <>
                        <Button onClick={() => setPendingModalVisible(false)}>Cancel</Button>
                        <Button type="primary" onClick={handleUpdateToPending}>Confirm</Button>
                    </>
                }
            >
                <FormItem label="Comments">
                    <TextArea
                        value={commentForm.comment}
                        onChange={handleCommentFormChange}
                        placeholder="Enter any comments (optional)"
                    />
                </FormItem>
            </Modal>

            {/* Mark as Completed Modal */}
            <Modal
                visible={completeModalVisible}
                title="Mark Payment as Completed"
                onClose={() => setCompleteModalVisible(false)}
                footer={
                    <>
                        <Button onClick={() => setCompleteModalVisible(false)}>Cancel</Button>
                        <Button type="primary" onClick={handleUpdateToCompleted}>Confirm</Button>
                    </>
                }
            >
                <FormItem label="Comments">
                    <TextArea
                        value={commentForm.comment}
                        onChange={handleCommentFormChange}
                        placeholder="Enter any comments (optional)"
                    />
                </FormItem>
            </Modal>

            {/* Refund Payment Modal */}
            <Modal
                visible={refundModalVisible}
                title="Refund Payment"
                onClose={() => setRefundModalVisible(false)}
                footer={
                    <>
                        <Button onClick={() => setRefundModalVisible(false)}>Cancel</Button>
                        <Button type="danger" onClick={handleRefundPayment}>Confirm Refund</Button>
                    </>
                }
            >
                <FormItem label="Reason for Refund">
                    <TextArea
                        value={refundForm.reason}
                        onChange={handleRefundFormChange}
                        placeholder="Enter reason for refund"
                        required
                    />
                </FormItem>
            </Modal>


            <Modal
                visible={emailModalVisible}
                title="Send Email to Customer"
                onClose={() => setEmailModalVisible(false)}
                footer={
                    <>
                        <Button onClick={() => setEmailModalVisible(false)}>Cancel</Button>
                        <Button
                            type="primary"
                            onClick={handleSendEmail}
                            disabled={sendingEmail}
                        >
                            {sendingEmail ? 'Sending...' : 'Send Email'}
                        </Button>
                    </>
                }
            >
                <FormItem label="To">
                    <Input
                        value={emailData.to}
                        readOnly
                    />
                </FormItem>
                <FormItem label="Subject">
                    <Input
                        value={emailData.subject}
                        onChange={handleEmailSubjectChange}
                        placeholder="Email subject"
                    />
                </FormItem>
                <FormItem label="Message">
                    <ReactQuill
                        theme="snow"
                        value={emailData.html}
                        onChange={handleEmailChange}
                        modules={{
                            toolbar: [
                                [{ 'header': [1, 2, false] }],
                                ['bold', 'italic', 'underline', 'strike'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ['link', 'image'],
                                ['clean']
                            ]
                        }}
                        style={{ height: '300px', marginBottom: '50px' }}
                    />
                </FormItem>
            </Modal>

        
            <EmailTemplateModal
                visible={isEmailModalVisible}
                onCancel={() => setIsEmailModalVisible(false)}
                onSend={handleSendEmail}
                lead={customer}
                userData={userData}
            />
        </div>
    );
};

export default PaymentPending;


